var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 20.6666C16.0623 20.6666 20.1663 16.5625 20.1663 11.4999C20.1663 6.43731 16.0623 2.33325 10.9997 2.33325C5.93706 2.33325 1.83301 6.43731 1.83301 11.4999C1.83301 16.5625 5.93706 20.6666 10.9997 20.6666Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 2.33325C8.64589 4.80473 7.33301 8.08693 7.33301 11.4999C7.33301 14.9129 8.64589 18.1951 10.9997 20.6666C13.3535 18.1951 14.6663 14.9129 14.6663 11.4999C14.6663 8.08693 13.3535 4.80473 10.9997 2.33325Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 11.5H20.1663",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.cbdf0748b6dc4da124c485795e899055.svg";
export { ForwardRef as ReactComponent };